<!--
 * @Description:客户详情底部按钮
 * @Author: cxh
 * @Date: 2022-09-20 15:19:34
 * @LastEditTime: 2022-09-20 18:57:22
 * @LastEditors: cxh
-->
<template>
  <cos-footer-button :loading="loading" hideOk>
    <a-button v-if="isPublicClue" v-permission="'fbu_public_customer_assign_btn'" type="primary" @click="handleAssignPerson">分配客户</a-button>
    <a-button v-if="!isPublicClue" @click="handleTransfer" v-permission="permissionPage?.transfer">转移客户</a-button>
    <a-button v-if="!isPublicClue" @click="handleAddConcat" v-permission="permissionPage?.concat_add">新增联系人</a-button>
    <a-button
      v-if="!isPublicClue"
      @click="handleAddFollow"
      v-permission="permissionPage?.follow_add"
      >写跟进</a-button
    >
    <a-button
      v-if="!isPublicClue"
      @click="hanleVisitor"
      v-permission="permissionPage?.visitor_add"
      >新增访客计划</a-button
    >
    <SellerButton v-if="!isPublicClue" controlType="none" :workCode="workCode" @click="handleAddBuss" v-permission="permissionPage?.buss_add"
      >新增商机</SellerButton
    >
    <a-button v-if="!isPublicClue" type="primary" @click="handleEdit" v-permission="permissionPage?.edit">编辑</a-button>
  </cos-footer-button>
  <!--转移客户--->
  <TransferModel ref="transferModelRef" @success="successPage('base')" />
  <!--新增联系人--->
  <ConcatModal ref="concatModalRef" @success="successPage('contact')" :contactRefId="route.query.cosId" />

  <CustomerAssign ref="customerAssignRef" @fetch="successPage('base')" />

</template>
<script setup lang="ts">
import { ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import TransferModel from './transferModel.vue'
import ConcatModal from '@/components/TabsContacts/fbu/editModal.vue'
import CustomerAssign from '@/views/gucangSales/customerCenter/components/customerAssign.vue'
const transferModelRef = ref()
const concatModalRef = ref()
const router = useRouter()
const route = useRoute()
const emit = defineEmits(['success'])
const props = defineProps({
  workCode: {
    type: String
  },
  type: {
    type: String
  },
  loading: {
    type: Boolean
  },
  data: {
    type: Object
  },
  isPublicClue: {
    type: Boolean
  },
  permissionPage: {
    type: Object,
    default: () => {
      return {}
    }
  }
})
// 转移客户
const handleTransfer = () => {
  transferModelRef.value.toggle([{ cosId: route.query.cosId }])
}
// 新增联系人
const handleAddConcat = () => {
  concatModalRef.value.toggle()
}
// 新增访客计划
const hanleVisitor = () => {
  router.push({
    path: '/fbu/visitorProgram/add',
    query: {
      saleChanceRefId: route.query.cosId
    }
  })
}

// 分配客户负责人
const customerAssignRef = ref()
const handleAssignPerson = () => {
  customerAssignRef.value?.init([props.data])
}

// 转移客户和新增联系人成功回调
const successPage = (tag: any) => {
  emit('success', tag)
}
// 新增跟进记录
const handleAddFollow = () => {
  router.push({
    path: '/fbu/followUpRecord/add',
    query: {
      followRefId: route.query.cosId
    }
  })
}
// 新增商机
const handleAddBuss = () => {
  router.push({
    path: '/fbu/business/add',
    query: {
      saleChanceRefId: route.query.cosId
    }
  })
}
//  编辑
const handleEdit = () => {
  let path = ''
  if (props.type === 'clients') {
    path = '/fbu/clients/edit'
  } else if (props.type === 'potential') {
    path = '/fbu/potential/edit'
  } else if (props.type === 'contract') {
    path = '/fbu/contract/edit'
  }
  if (path) {
    router.push({
      path,
      query: {
        cosId: route.query.cosId
      }
    })
  }
}
</script>
<script lang="ts">
export default { name: 'viewFooterBtn' }
</script>
